
export function uuidv4() {
	return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
		(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
	);
}

export function capitalize(s) {
	return s[0].toUpperCase() + s.slice(1);
}

export function extractRangeMinAndMax(input) {
	const rangePart = input.substring(input.indexOf('(') + 1, input.indexOf(')'));
	const [minStr, maxStr] = rangePart.split('-');
	const minValue = parseInt(minStr, 10);
	const maxValue = parseInt(maxStr, 10);
	return { min: minValue, max: maxValue };
}

export const rangeValidation = (min, max) => {
	let minError = "";
	let maxError = "";
	
	if(min == null)
		minError = `Min should not be empty`;
	else if(min != null && min < 1)
		minError = `Min should be greater than 0`;
	else if(min != null && max != null) {
		if(min == max)
			minError = `Min and max should not be same`;
		else if(min > max)
			maxError = `Max should be greater than min`;
	}
		
	if(max == null)
		maxError = `Max should not be empty`;
	else if(max != null && max < 1)
		maxError = `Max should be greater than 0`;

	return { 
		"minError" : minError,
		"maxError" : maxError
	}
}